export default __webpack_public_path__ + "static/media/mariaFilo_mob_banner_4.71674289.jpg";